import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';

// Action Types
export const GET_PROVIDER_SERVICE_LIST = 'GET_PROVIDER_SERVICE_LIST';
export const GET_PROVIDER_SERVICE_LIST_SUCCESS =
  'GET_PROVIDER_SERVICE_LIST_SUCCESS';
export const GET_PROVIDER_SERVICE_LIST_FAILURE =
  'GET_PROVIDER_SERVICE_LIST_FAILURE';

// Action Creators
export const fetchGetProviderService = () => ({
  type: GET_PROVIDER_SERVICE_LIST,
});

export const fetchGetProviderServiceSuccess = (data) => ({
  type: GET_PROVIDER_SERVICE_LIST_SUCCESS,
  payload: data,
});

export const fetchGetProviderServiceFailure = (error) => ({
  type: GET_PROVIDER_SERVICE_LIST_FAILURE,
  payload: error,
});

export const getProviderServiceCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetProviderService(data, external));
    try {
      const response = await getMethodWithToken(
        url.getProviderService + external?.id + '/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetProviderServiceSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetProviderServiceFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetProviderServiceFailure(error.message));
    }
  };
};
